// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://auth.brrgr.com";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_ZHi_EKwgp6aWwC8odpOd3A_9Tp1uY7H";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Ensure OAuth redirects (Google/Apple) are exchanged into a session on return.
    detectSessionInUrl: true,
  },
});